import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import BackIcon from "@fortawesome/fontawesome-free-solid/faLongArrowAltLeft";

import { TextInput, Button2 } from "../../../common";
import Icon from "../../../common/icon";
import { validateUserToken, updateUser } from "../../../../helpers/ApiManager";

import * as Strings from "./strings";
import * as Functions from "../../../../helpers/Functions";
import * as Constants from "../../../../helpers/Constants";
import * as userActions from "../../../../actions/User";
import * as configActions from "../../../../actions/Config";

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      passwordInput: "",
      repeatPasswordInput: "",
      loading: false,
      id: null,
      communityId: null,
      error: { hasError: false },
    };

    this.enterHandler = this.enterHandler.bind(this);
  }

  componentWillMount() {
    window.addEventListener("keypress", this.enterHandler);

    const { match } = this.props;
    const { idToken } = match.params;
    validateUserToken(
      idToken,
      (response) => {
        this.setState({
          id: response.userId,
          communityId: response.communityId,
          loading: false,
        });
      },
      (error) => {
        if (error && error.status === 401)
          this.setState({
            loading: false,
            error: { hasError: true, status: 401 },
          });
        else
          this.setState({
            loading: false,
            error: { hasError: true, status: 500 },
          });
      }
    );
  }

  componentWillUnmount() {
    window.removeEventListener("keypress", this.enterHandler);
  }

  changePassword() {
    const { match, config } = this.props;
    const { idToken } = match.params;
    const { passwordInput, id, communityId, repeatPasswordInput } = this.state;

    if (passwordInput === "") {
      this.props.showAlert(
        Strings.default.MANDATORY_FIELDS[config.language],
        Strings.default.MANDATORY_FIELDS_INFO[config.language],
        Constants.ONE_BUTTON,
        { title: Strings.default.OK[config.language], onPress: () => {} }
      );
    } else if (passwordInput !== repeatPasswordInput) {
      this.props.showAlert(
        Strings.default.PASSWORDS_DONT_MATCH[config.language],
        Strings.default.PASSWORDS_DONT_MATCH_INFO[config.language],
        Constants.ONE_BUTTON,
        { title: Strings.default.OK[config.language], onPress: () => {} }
      );
    } else {
      updateUser(
        idToken,
        id,
        communityId,
        { password: passwordInput, resetPassword: true },
        (response) =>
          this.props.showAlert(
            Strings.default.PASSWORD_UPDATED[config.language],
            Strings.default.PASSWORD_UPDATED_INFO[config.language],
            Constants.ONE_BUTTON,
            { title: Strings.default.OK[config.language], onPress: () => {} }
          ),
        (error) => console.log(error)
      );
    }
  }

  enterHandler(e) {
    const { alert } = this.props;
    if (e.charCode === 13 && alert.id === null) {
      this.changePassword();
    } else {
      this.props.hideAlert();
    }
  }

  getString(key) {
    const { config } = this.props;

    return Functions.getString(key, config.language);
  }

  renderContent() {
    const { config } = this.props;
    const { passwordInput, repeatPasswordInput, loading, error } = this.state;
    const { errorTextStyle } = styles;

    if (error.hasError) {
      if (error.status === 401) {
        return (
          <p style={errorTextStyle}>
            {this.getString("invalidTokenText1")}
            <span
              style={{
                color: Constants.WHITE_LABEL.colors.primary,
                textDecoration: "underline",
              }}
            ></span>
            {this.getString("invalidTokenText2")}
          </p>
        );
      } else {
        return (
          <p style={errorTextStyle}>
            {this.getString("somethingWentWrongPleaseReload")}
          </p>
        );
      }
    }
    // change
    return (
      <div className={"basicContainer"}>
        <h5>{Strings.default.NEW_PASSWORD[config.language]}</h5>
        <Input
          header={Strings.default.PASSWORD[config.language] + "*"}
          value={passwordInput}
          type={"password"}
          onChange={(text) => this.setState({ passwordInput: text })}
        />
        <Input
          header={Strings.default.REPEAT_PASSWORD[config.language] + "*"}
          value={repeatPasswordInput}
          type={"password"}
          onChange={(text) => this.setState({ repeatPasswordInput: text })}
        />
        <Button2
          header={Strings.default.CHANGE_PASSWORD[config.language]}
          onClick={() => this.changePassword()}
          loading={loading}
        />
      </div>
    );
  }

  render() {
    return (
      <div className={"basicCentered"}>
        <div
          onClick={() => this.props.history.push("/")}
          className={"backSection"}
        >
          <FontAwesomeIcon className={"backIcon"} icon={BackIcon} />
          <p className={"backText"}> {this.getString("backToLogin")}</p>
        </div>
        {this.renderContent()}
      </div>
    );
  }
}

const Input = ({ header = "", value, onChange, type }) => {
  return (
    <TextInput
      width={"100%"}
      header={header}
      type={type}
      value={value}
      onChange={(value) => onChange(value)}
      underlineFocusStyle={{
        borderColor: Constants.WHITE_LABEL.colors.primary,
      }}
      floatingLabelFocusStyle={{ color: Constants.WHITE_LABEL.colors.primary }}
    />
  );
};

const styles = {
  errorTextStyle: { fontSize: 22, color: "#3b424d", zIndex: 10 },
};

function mapStateToProps({ config }) {
  return { config };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...userActions, ...configActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/pages/preLogin/ResetPassword/index.js